<template>
  <div id="app" :data-version="version">
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'app',
    data: () => ({
      version: process.env.VERSION
    }),
  }
</script>

<style lang="css">
  body {
    padding: 0;
    margin: 0;
    background: transparent;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media (max-width: 991px) {
    #app {
      height: 100vh;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?382fd71b